export const iconFontAwesomeBuildingsBuildingLock = (
	<i className="fa-solid fa-building-lock"></i>
);
